import { useEffect, useState } from 'react';

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [newItemName, setNewItemName] = useState('');

  const sortItemsByName = (items) => [...items].sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/admin/inventory`, {
        credentials: 'include',
      });
      const data = await res.json();
      console.log(data);
      setItems(data);
    } catch (err) {
      console.error('Failed to fetch inventory', err);
    }
  };

  const toggleAvailability = async (item) => {
    const res = await fetch(
      `${process.env.REACT_APP_EXPRESS_URL}/api/admin/inventory/${item.id}/available`,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ available: !item.available }),
      }
    );
    if (res.ok) {
      setItems((prev) =>
        prev.map((i) => (i.id === item.id ? { ...i, available: !i.available } : i))
      );
    }
  };

  const toggleLow = async (item) => {
    const res = await fetch(
      `${process.env.REACT_APP_EXPRESS_URL}/api/admin/inventory/${item.id}/low`,
      {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ low: !item.low }),
      }
    );
    if (res.ok) {
      setItems((prev) => prev.map((i) => (i.id === item.id ? { ...i, low: !i.low } : i)));
    }
  };

  const deleteItem = async (itemId) => {
    const res = await fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/admin/inventory/${itemId}`, {
      method: 'DELETE',
      credentials: 'include',
    });
    if (res.ok) {
      setItems((prev) => prev.filter((i) => i.id !== itemId));
    }
  };

  const handleAddItem = async (e) => {
    e.preventDefault();
    if (!newItemName.trim()) return;

    const res = await fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/admin/inventory`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: newItemName.trim() }),
    });

    if (res.ok) {
      const [newItem] = await res.json();
      setItems((prev) => sortItemsByName([...prev, newItem]));
      setNewItemName('');
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-4 border border-pink-200 dark:border-gray-700 rounded-lg shadow">
      <h2 className="text-xl font-bold text-pink-700 dark:text-pink-300 mb-4">Inventory</h2>

      <form onSubmit={handleAddItem} className="flex items-center gap-2 mb-4">
        <input
          type="text"
          placeholder="Add new item"
          value={newItemName}
          onChange={(e) => setNewItemName(e.target.value)}
          className="flex-grow px-3 py-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-black dark:text-white"
        />
        <button
          type="submit"
          className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded"
        >
          Add
        </button>
      </form>

      <ul className="space-y-3 text-sm text-gray-700 dark:text-gray-200">
        {items.map((item) => (
          <li
            key={item.id}
            className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 p-2 border-b border-gray-200 dark:border-gray-700"
          >
            <span className="font-medium">{item.name}</span>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input
                  type="checkbox"
                  checked={item.available}
                  onChange={() => toggleAvailability(item)}
                  className="w-5 h-5 accent-pink-600"
                />
                <span className="text-xs">Available</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="checkbox"
                  checked={item.low}
                  onChange={() => toggleLow(item)}
                  className="w-5 h-5 accent-yellow-500"
                />
                <span className="text-xs text-yellow-700">Low</span>
              </label>
              <button
                onClick={() => deleteItem(item.id)}
                className="text-red-500 hover:text-red-700 text-sm"
              >
                🗑️
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
